module.exports = __webpack_public_path__ + "img/fond-zebre-xs@2x.4867c591.jpg";